module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuAgMAAAAq18OkAAAACVBMVEUAAAAeEwP///+P9O6FAAAAAXRSTlMAQObYZgAAAB9JREFUKM9jYEAGoqFw4IDKEVsFAytHOSOYgzuFIAMAwHYllM6u+kUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_address.png
// module id = rGz7
// module chunks = 0